<template>
  <div>
    <b-form-checkbox v-model="valueLocal" :value="true" :unchecked-value="false">
      <span class="title">{{ title }}</span>
      <Tip :field="field" :formName="formName" />
    </b-form-checkbox>
  </div>
</template>

<script>
import Tip from "../shared/Tip.vue";

import { mapMutations } from "vuex";

export default {
  components: { Tip },
  name: "CheckboxSimple",
  props: {
    title: String,
    formName: String,
    fieldTarget: String,
    field: String,
    value: Boolean,
    changed: Function,
    params: Object,
    markFormDirty: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      valueLocal: false,
    };
  },
  methods: {
    ...mapMutations("validation", ["updateFormDirty"]),
    ...mapMutations("generic", ["addFilter"]),
  },
  mounted() {
    this.valueLocal = this.value;
  },
  watch: {
    value() {
      this.valueLocal = this.value;
    },
    valueLocal() {
      this.$emit("input", this.valueLocal);
      if (this.markFormDirty) this.updateFormDirty(true);
      if (this.changed) this.changed(this.params);

      if (this.fieldTarget) {
        let obj = { fieldTarget: this.fieldTarget, value: this.valueLocal ? "true" : "false" };
        this.addFilter(obj);
      }
    },
  },
};
</script>
